import React, { useState } from "react";
import logoInsto from "../assets/logo-insto.png";
export default function Header() {
  const [showMenu, setShowMenu] = useState(false);

  let activeClass = "";

  if (showMenu) {
    activeClass = "active";
  }

  function toggleMenu() {
    setShowMenu(!showMenu);
  }

  return (
    <>
      <div class={`logo-header ${activeClass}`}>
        <div class="container">
          <a href="/" class="logo-insto">
            <img src={logoInsto} alt="" />
          </a>
          <div class="right-container">
            <a
              href="https://www.combiphar.com/"
              target="_blank"
              class="logo-combiphar is-shown"
            >
              <img src="https://insto.co.id/images/logo-combiphar.png" alt="" />
            </a>

            <div style={{ padding: "0 10px" }}></div>

            <div class="separator on-top"></div>

            <button
              id="nav-menu-btn"
              className={activeClass}
              onClick={toggleMenu}
            >
              <div class="hamburger"></div>
            </button>
          </div>
        </div>
      </div>
      <div class="wavy white wavy-1" style={{ top: 100, left: -40 }}></div>
      <div class="wavy white wavy-2" style={{ right: -40, bottom: 60 }}></div>
      <div id="main-menu" class={`z40 ${activeClass}`}>
        <div class="menu-container">
          <div class="wavy white wavy-1"></div>
          <div class="wavy white wavy-2"></div>
          <div class="menu-wrapper">
            <label>Menu</label>

            <div class="menu-content">
              <a class="menu-1" href="/tentang-insto">
                <span>Tentang INSTO</span>
              </a>
              <a class="menu-2" href="/eyeducation">
                <span>Eyeducation</span>
              </a>
              <a class="menu-3" href="/contact">
                <span>Contact Us</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
